
import { Link } from "gatsby"
import React from "react"

const Menu = (props) => (
  <nav className={props.active ? 'active' : ''}>
    <Link to="/">
      Home
     </Link>


     <Link to="/blog">
       Blog
    </Link>

    <Link to="/about">
      About
    </Link>
  </nav>
)

export default Menu
